import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import { ContainerWithBusyIndicator } from "../BusyIndicator/ContainerWithBusyIndicator";
import styles from "./ActionListItem.module.less";

export type ActionListBusyIndicatorProps = {
	trackingId?: string;
};

export const ActionListBusyIndicator = (props: ActionListBusyIndicatorProps): ReactElement => {
	const {
		trackingId
	} = props;

	return (
		<li
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.root,
				styles.root_loading
			)}
		>
			<ContainerWithBusyIndicator
				hasBusyIndicator
				size="fill"
			/>
		</li>
	);
};
ActionListBusyIndicator.displayName = "ActionListBusyIndicator";
